<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{ dialogData.data && dialogData.data.name != "" ? 'Edit Revenue/Expense (' + dialogData.data.id + ')' : 'Add New
    Revenue/Expense' }}
  </div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="editForm" (ngSubmit)="onSave()" class="form-grid">
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" data-testid="name" required maxlength="75">
        @if (editForm.get('name')?.invalid && editForm.get('name')?.touched) {
        <mat-error>Name is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Invoice #</mat-label>
        <input matInput formControlName="invoiceNumber" data-testid="invoiceNumber" required maxlength="15">
        @if (editForm.get('invoiceNumber')?.invalid && editForm.get('invoiceNumber')?.touched) {
        <mat-error>Invoice Number is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Price</mat-label>
        <input matInput type="text" data-testid="price" formControlName="price" required
          (input)="roundOff($event, 999999, 4, 'price')">
        @if (editForm.get('price')?.invalid && editForm.get('price')?.touched) {
        <mat-error>Price is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Expense Type</mat-label>
        <mat-select formControlName="expenseType" required data-testid="expenseType">
          <mat-option [value]="null">-Select Expense Type-</mat-option>
          @for (type of dialogData.expenseTypes; track type.id) {
          <mat-option [value]="type.id">{{ type.name }}</mat-option>
          }
        </mat-select>
        @if (editForm.get('expenseType')?.invalid && editForm.get('expenseType')?.touched) {
        <mat-error>Expense Type is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-slide-toggle formControlName="expensive" data-testid="expensive" color="primary"
        class="bill-to-customer-checkbox" labelPosition="before">Bill to customer?</mat-slide-toggle>
    </div>

  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-raised-button color="primary" mat-primary data-testid="btnClose" (click)="onClose()">Cancel</button>
  @if(canSave){
    <button mat-raised-button color="primary" mat-primary data-testid="btnSave" (click)="onSave()">Save</button>
  }
</mat-dialog-actions>